/** DIRECTIVE GUIDE
 *
 * The directive display a colored exclamation mark with a message upon validation of the input field
 *
 *  Construct:
 *
 * <i (_message)="msg = $event" ptvmValidate [ptvmConstraint]="!model" [ptvmType]="'pattern'"
    [ptvmMessage]="'email'" [ptvmPattern]="'email'" ngbTooltip="Questo campo è richiesto" [ptvmModel]="model"
    class="ptvm-validate">
  </i>
 *
 *
 * To validate required fields:
 *
 * ptvmType --> 'required'
 * ptvmMessage --> 'mandatory'
 * ptvmPattern --> REMOVE IT
 *
 *
 * To validate patterns:
 *
 * ptvmType --> 'pattern'
 * ptvmMessage --> pass the pattern message, either: 'piva', 'cf', 'cap', 'email', 'password', 'mismatch' (to check password match) or other futures message types
 * ptvmPattern --> pass the pattern type, either: 'piva', 'cf', 'cap', 'email', 'password', 'username'
 *
 *
 * To validate password match:
 *
 * ptvmType --> 'password'
 * ptvmMessage --> 'mismatch'
 * ptvmPattern --> REMOVE IT
 *
*/

import { Directive, ElementRef, EventEmitter, HostBinding, Input, Output } from '@angular/core';

enum ValidationType {
    'required' = 'red',
    'pattern' = 'orange',
    'password' = 'purple',
    'info' = '#1c8dc9'
}

export enum ValidationPattern {
    'piva' = '^[0-9]{11}$',
    'cf' = '^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$',
    'cap' = '^[0-9]{5}$',
    'email' = '^[a-zA-Z0-9\\-_]{1,150}@[a-zA-Z0-9\\-_]{1,43}\\.[a-zA-Z0-9]{1,5}$',
    'password' = '^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z0-9])|(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9])|(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9])).{8,}$',
    'username' = '^[a-zA-Z0-9-_\\.]{4,20}$',
    'pdr' = '^[0-9]{14}$',
    'pod' = '^(it|IT)([0-9]{3})(e|E)([0-9]{8})$',
    'iban' = '^(it|IT)[0-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$',
    'identity_card' = '^[A-Za-z]{2}[0-9]{7,8}$'
}

export enum ValidationMessage {
    'mandatory' = 'Questo campo è richiesto',
    'mismatch' = 'I valori inseriti non corrispondono',
    'piva' = 'La PIVA deve contenere 11 cifre',
    'cf' = 'Il codice fiscale deve contenere 16 caratteri alfanumerici',
    'cap' = 'Il CAP deve contenere 5 cifre',
    'email' = 'È necessario inserire un indirizzo email valido',
    // tslint:disable-next-line:max-line-length
    'password' = 'La password deve contenere almeno 8 caratteri - Almeno una lettera maiuscola - Almeno una minuscola - Almeno un numero',
    'username' = "Dai 4 ai 20 caratteri alfanumerici. Può contenere '.' e/o '_'. Deve cominciare con una lettera.",
    'pdr' = 'Devono essere 14 cifre',
    'pod' = "'IT' seguito da 3 cifre seguito da 'E' seguito da 8 cifre.",
    'iban' = "L'IBAN deve rispettare il formato standard italiano."
}

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[ptvmValidate]'
})
export class ValidationDirective {
    @Input() ptvmType: string;

    // show/hide the mark based on validation constraint
    @Input()
    set ptvmConstraint(value: boolean) {
        if (value) {
            this.selectedType = true;
            this.elRef.nativeElement.style.color = ValidationType[this.ptvmType];
        } else {
            this.selectedType = false;
        }
    }

    // show/hide the mark based on pattern match
    private pattern: RegExp;
    @Input()
    set ptvmPattern(value: string) {
        this.pattern = new RegExp(ValidationPattern[value]);
    }

    // pass the model to listen for changes
    @Input()
    set ptvmModel(value: any) {
        if (value) {
            this.selectedType = this.pattern && this.pattern.test(value) === false;
        } else {
            this.selectedType = true;
        }
    }

    // manages tooltip text
    @Output() _message = new EventEmitter<string>(true);

    @Input()
    set ptvmMessage(value: string) {
        if (value) {
            this._message.emit(ValidationMessage[value]);
        }
    }

    @HostBinding('class.ptvm-validate') selectedType: boolean;

    constructor(private elRef: ElementRef<HTMLInputElement>) {}
}



// WEBPACK FOOTER //
// ./src/app/directives/validation.directive.ts